import { render, staticRenderFns } from "./CustomerAddressTax.vue?vue&type=template&id=22fa7d2a&scoped=true&"
import script from "./CustomerAddressTax.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressTax.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAddressTax.vue?vue&type=style&index=0&id=22fa7d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa7d2a",
  null
  
)

component.options.__file = "CustomerAddressTax.vue"
export default component.exports